// @flow strict

import useI18n from 'src/hooks/useI18n';


export default function useLabelTranslation(): {
  t: (key: string, defaultValue: string) => string,
  makeKey: (value: string) => string,
} {
  const {labelI18nInstance} = useI18n();
  const makeKey = (value: string) => {
    try {
      if (value && typeof value === 'string') {
        return value
          .replace(/[^\w\s']/g, '') // remove special characters except apostrophe
          .replace(/\s+/g, '_'); // replace spaces with underscores
      }
      return value;
    } catch {
      return value;
    }
  };
  return {
    t: labelI18nInstance.t,
    makeKey,
  };
}
